export const FISERV_CARD_OPTIONS = [
  {
    id: "visa",
    label: "Visa",
    storeId: "59307167997660",
    installments: [
       { value: 1, label: "1 cuota (sin interés)", rate: 0 },
       { value: 2, label: "2 cuotas", rate: 0.0578 },
      { value: 3, label: "3 cuotas", rate: 0.0678 },
      { value: 6, label: "6 cuotas", rate: 0.1452 },
      { value: 9, label: "9 cuotas", rate: 0.2299 },
      { value: 12, label: "12 cuotas", rate: 0.2904 },
    ],
  },
  {
    id: "mastercard",
    label: "Mastercard",
    storeId: "59307167997661",
    installments: [
       { value: 1, label: "1 cuota (sin interés)", rate: 0 },
       { value: 2, label: "2 cuotas", rate: 0.0578 },
      { value: 3, label: "3 cuotas", rate: 0.0678 },
      { value: 6, label: "6 cuotas", rate: 0.1452 },
      { value: 9, label: "9 cuotas", rate: 0.2299 },
      { value: 12, label: "12 cuotas", rate: 0.2904 },
    ],
  },
  {
    id: "maestro",
    label: "Maestro",
    storeId: "59307167997662",
    installments: [
       { value: 1, label: "1 cuota (sin interés)", rate: 0 },
       { value: 2, label: "2 cuotas", rate: 0.0578 },
      { value: 3, label: "3 cuotas", rate: 0.0678 },
      { value: 6, label: "6 cuotas", rate: 0.1452 },
      { value: 9, label: "9 cuotas", rate: 0.2299 },
      { value: 12, label: "12 cuotas", rate: 0.2904 },
    ],
  },
  {
    id: "naranja",
    label: "Naranja",
    storeId: "59307167997663",
    installments: [
       { value: 1, label: "1 cuota (sin interés)", rate: 0 },
      { value: 3, label: "3 cuotas", rate: 0.1899 },
      { value: 6, label: "6 cuotas", rate: 0.3887 },
      { value: 9, label: "9 cuotas", rate: 0.4843 },
      { value: 12, label: "12 cuotas", rate: 0.6392 },
    ],
  },
    {
    id: "cabal",
    label: "Cabal",
    storeId: "59307167997664",
    installments: [
       { value: 1, label: "1 cuota (sin interés)", rate: 0 },
       { value: 2, label: "2 cuotas", rate: 0.0578 },
      { value: 3, label: "3 cuotas", rate: 0.0678 },
      { value: 6, label: "6 cuotas", rate: 0.1452 },
      { value: 9, label: "9 cuotas", rate: 0.2299 },
      { value: 12, label: "12 cuotas", rate: 0.2904 },
    ],
  },
   {
    id: "americanexpress",
    label: "American Express",
    storeId: "5930716799765",
    installments: [
       { value: 1, label: "1 cuota (sin interés)", rate: 0 },
       { value: 2, label: "2 cuotas", rate: 0.0578 },
      { value: 3, label: "3 cuotas", rate: 0.0678 },
      { value: 6, label: "6 cuotas", rate: 0.1452 },
      { value: 9, label: "9 cuotas", rate: 0.2299 },
      { value: 12, label: "12 cuotas", rate: 0.2904 },
    ],
  },
];


export const calculateInstallmentTotal = (baseAmount = 0, rate = 0) => {
  const amount = Number(baseAmount) || 0;
  const surcharge = Number(rate) || 0;

  return Math.round(amount * (1 + surcharge) * 100) / 100;
};
